    import { Injectable } from '@angular/core';
import { TokenService } from '../Interceptor/token.service';
import { environment } from '../../environments/environment';
    import { HttpClient } from '@angular/common/http';
    @Injectable({
      providedIn: 'root',
    })
    export class RefreshTokenService {
        constructor(private http: HttpClient, private tokenService: TokenService) {}

    // refreshToken() {
    //     const accessToken = localStorage.getItem('accessToken');
    //     if (!accessToken) return Promise.resolve(false);

    //     // Call your API to refresh the token
    //     return this.http
    //         .post(`${environment.authApiUrl}refresh-token`, { accessToken })
    //         .toPromise()
    //         .then((response: any) => {
    //             console.log('🔄 Refresh token response:', response);

    //             const newToken = response?.accessToken;
    //             if (newToken) {
    //                 console.log('🔄 New access token received:', newToken);
    //                 localStorage.setItem('accessToken', newToken);
    //                 this.tokenService.setToken(newToken);
    //                 return true;
    //             }
    //             return false;
    //         })
    //         .catch((error) => {
    //             console.error('❌ Refresh token API failed:', error);
    //             return false;
    //         });
    // }

//     refreshToken() {
//   let accessToken = localStorage.getItem('accessToken');
//     if (!accessToken) return Promise.resolve(false);
//     if (accessToken?.startsWith('"') && accessToken?.endsWith('"')) {
//         accessToken = accessToken.slice(1, -1);
//     }
//     const headers = { Authorization: `Bearer ${accessToken}` };

//     // Call your API to refresh the token with Authorization header
//     return this.http
//         .post(`${environment.authApiUrl}refresh-token`, {}, { headers })
//         .toPromise()
//         .then((response: any) => {
//             console.log('🔄 Refresh token response:', response);

//             const newToken = response?.accessToken;
//             if (newToken) {
//                 console.log('🔄 New access token received:', newToken);
//                 localStorage.setItem('accessToken', newToken);
//                 this.tokenService.setToken(newToken);
//                 return true;
//             }
//             return false;
//         })
//         .catch((error) => {
//             console.error('❌ Refresh token API failed:', error);
//             return false;
//         });
// }

refreshToken() {
    let accessToken = localStorage.getItem('accessToken') || localStorage.getItem('auth_token');
    if (!accessToken) return Promise.resolve(false);
    if (accessToken?.startsWith('"') && accessToken?.endsWith('"')) {
        accessToken = accessToken.slice(1, -1);
    }
    const headers = { Authorization: `Bearer ${accessToken}` };

    // Include token in payload as well as header
    const payload = { accessToken };

    return this.http
        .post(`${environment.authApiUrl}refresh-token`, payload, { headers })
        .toPromise()
        .then((response: any) => {
            console.log('🔄 Refresh token response:', response);

            const newToken = response?.accessToken;
            if (newToken) {
                console.log('🔄 New access token received:', newToken);
                localStorage.setItem('accessToken', newToken);
                this.tokenService.setToken(newToken);
                return true;
            }
            return false;
        })
        .catch((error) => {
            console.error('❌ Refresh token API failed:', error);
            return false;
        });
}


}